import { Molecule, wrap } from 'AppReact';
import styled from 'styled-components';
import { Mr2 } from 'wrappers';
import { Icon, SecondaryTextSm } from 'atoms';
import { getIconByName } from 'utils';

const template = styled.div`
  display: flex;
  align-items: center;
`;

export default Molecule({
  template,
  atoms: [
    {
      component: wrap(Icon, Mr2),
      name: 'WaitingOnParts',
      renderIf: ({ order }) => order.parent_category_icon,
      displayValue: ({ order }) => getIconByName({ name: order.parent_category_icon, width: 15, height: 15 }),
    },
    {
      component: SecondaryTextSm,
      name: 'Unit',
      displayValue: ({ order }) => order?.parent_category_name ?? '',
    },
  ],
});
